import { useQuery } from "react-query";
import { Link as ReactRouterLink } from "react-router-dom";

import { List, ListItem, ListItemButton, Typography } from "@mui/joy";
import { FileApi } from "../api/file";
import { PrimeQueryKeys } from "../shared/constants";
import FileIcon from "./FileIcon";

export default function DocumentList() {
    const { data: fileData } = useQuery(PrimeQueryKeys.allFiles, FileApi.getAllFiles);
    const files = fileData ?? [];

    return (
        <>
            <List>
                {files.map((f) => (
                    <ListItem key={f.id}>
                        <ListItemButton component={ReactRouterLink} to={`/doc/${f.id}`}>
                            <Typography
                                noWrap
                                fontSize="sm"
                                sx={{ flex: 1 }}
                                startDecorator={<FileIcon fileName={f.fileName} />}
                            >
                                {f.fileName}
                            </Typography>
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </>
    );
}
